import { appInfo } from "@/common/data/appinfo";

export default [
  {
    path: "/fngyeiuvyitye9oiut8rdoyier98titye",
    name: "departments-list",
    meta: {
      title: appInfo?.type === "codsms" ? "Section classes" : "Departments",
      authRequired: true,
      acc: ["v75"],
    },
    component: () => import("../views/department/department-list"),
  },
  {
    path: "/uwnvtwaoitnir8sthiriethnituvw",
    name: "new-department",
    meta: {
      title:
        appInfo?.type === "codsms" ? "New Section class" : "New department",
      authRequired: true,
      acc: ["v67"],
    },
    component: () => import("../views/department/new-department"),
  },

  // assignments
  {
    path: "/uwnvtwaoitnir8sthiriethsadasdadsdanituvw",
    name: "assign-department",
    meta: {
      title:
        appInfo?.type === "codsms"
          ? "Assign Section class"
          : "Assign department",
      authRequired: true,
      acc: ["y76272"],
    },
    component: () => import("../views/department/assign.vue"),
  },
  {
    path: "/DNSDYANDTBADASDYBADYASIDBAD",
    name: "assigned-departments-list",
    meta: {
      title:
        appInfo?.type === "codsms"
          ? "Assigned Section Classes"
          : "Assigned Departments",
      authRequired: true,
      acc: ["y90033"],
    },
    component: () => import("@/views/department/assigned.vue"),
  },

  // end
  {
    path: "/uibfsubyfvsiuysncfuiyfniuye/:department?",
    name: "department",
    meta: {
      title: appInfo?.type === "codsms" ? "Section class" : "Department",
      authRequired: true,
      acc: ["v19"],
    },
    component: () => import("../views/department/view"),
  },
  {
    path: "/nwucybwiukywetivnyrtyutienhreit/:departmenti?",
    name: "edit-department",
    meta: {
      title:
        appInfo?.type === "codsms" ? "Edit Section class" : "Edit Department",
      authRequired: true,
      acc: ["v66"],
    },
    component: () => import("../views/department/edit.vue"),
  },
];
